import { getAllTrackingProperties, getDefaultTrackingProperties, parseISODate } from '$lib/helper';

import type { Language } from '$lib/types/Language';
import type { TrackingProperty } from '$lib/types/TrackingProperty';

const ENTITY_MAP: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
};

const ENTITY_RE = /[&<>"']/g;

export const escapeHtml = (str: string): string => {
    return str.replace(ENTITY_RE, (ch) => ENTITY_MAP[ch]);
};

export const personalizeHtml = (
    html: string,
    {
        trackingProperties,
        campaignId,
        language = 'en',
    }: {
        trackingProperties: TrackingProperty[];
        campaignId: string;
        language?: Language;
    },
): string => {
    const defaultTrackingProperties = getDefaultTrackingProperties(trackingProperties);
    const savedTrackingProperties = getAllTrackingProperties(campaignId);

    const propertyById = new Map<string, TrackingProperty>();
    trackingProperties.forEach((prop) => {
        propertyById.set(prop._id, prop);
    });

    return html.replace(/<span[^>]*?data-type="mention"[^>]*?>[\s\S]*?<\/span>/g, (match) => {
        const idMatch = match.match(/data-id="([^"]*)"/);

        if (!idMatch) return match;

        const mentionId = idMatch[1];
        const property = propertyById.get(mentionId);

        if (!property) {
            return match;
        }

        const replaceValue =
            savedTrackingProperties[property.fieldName] ??
            defaultTrackingProperties[property.fieldName];

        if (!replaceValue) {
            return match;
        }

        const formatted = parseISODate(replaceValue, language);
        const escaped = escapeHtml(formatted);

        return match.replace(/>[\s\S]*?<\/span>$/, `>${escaped}</span>`);
    });
};
